'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadByChannel = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getThreadByChannelInProps = function getThreadByChannelInProps(state, _ref) {
  var channel = _ref.channel;
  return (0, _getIn2.default)(['conversations', 'conversationsMap', channel], state);
};

var getThreadByChannel = exports.getThreadByChannel = (0, _reselect.createSelector)([getThreadByChannelInProps], function (thread) {
  return thread;
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getThreadByChannel.js
// module id = 48
// module chunks = 2 3